import { DisplayDataBlock, NavItem, NavListItemWithBlockDescription } from '@billy/design-system'
import { TFunction } from 'i18next'

import { LocaleIdentifier } from '../../../../../types/localeIdentifier'
import { TaxRateGroup } from '../../../types/taxRateGroup'
import { VatRate } from '../../../types/vatRate'
import { VatRateItemValue } from '../types/vatRateItemValue'
import { getDisplayedVatRate } from './getDisplayedVatRate'
import { getGroupedVatRateItems } from './getGroupedVatRateItems'

interface GetItemsOptions {
  locale: LocaleIdentifier
  region: TaxRateGroup | undefined
  t: TFunction
  vatRates: VatRate[]
  withDetails?: boolean
}

export const getItems = ({
  locale,
  region,
  t,
  vatRates,
  withDetails,
}: GetItemsOptions): NavItem<VatRateItemValue>[] => {
  // if there's no region specified, we group all the VatRates by regions (and if there's
  // a specific region provided, it's only that one, so there's no need for grouping)
  const shouldGroupByRegions = region === undefined

  const items: NavItem<VatRateItemValue>[] = vatRates.map((vatRate) => {
    const { description, id, name, taxRateGroup: vatRateRegion } = vatRate
    const displayedRate = getDisplayedVatRate({ vatRate, locale })

    const displayData: DisplayDataBlock = withDetails
      ? {
          description,
          title: name,
          shouldShowSuffixOnHover: false,
        }
      : {
          title: displayedRate,
          suffix: <NavListItemWithBlockDescription.DescriptionSuffix name={displayedRate} description={description} />,
        }

    return {
      id,
      children: name,
      searchKeywords: [displayedRate],
      value: {
        ...vatRate,
        displayData,
      },
      ...(shouldGroupByRegions
        ? {
            accessorGroupId: vatRateRegion,
          }
        : {}),
    }
  })

  return shouldGroupByRegions ? getGroupedVatRateItems(items, t) : items
}
